<template>
  <div>
    <div v-if="isLoading" class="text-center pt-3">
      <b-spinner label="Loading..." />
    </div>

    <b-card-group
      v-else-if="survey.completed"
      deck
      class="justify-content-center"
    >
      <b-card no-body style="max-width: 560px" class="mb-3">
        <b-card-body>
          <b-card-title>Submitted Answers</b-card-title>
        </b-card-body>

        <b-list-group flush>
          <b-list-group-item v-for="detail in survey.details" :key="detail.key">
            <strong>{{ detail.title }}</strong> {{ detail.value }}
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-card-group>

    <b-card
      v-else
      no-body
      style="max-width: 560px"
      class="mb-3 mx-auto"
    >
      <b-card-body>
        <b-card-title>Charter survey unavailable</b-card-title>
        <p class="mb-0 text-muted">
          Public charter survey submission has been disabled. Existing answers can still be viewed when available.
        </p>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BSpinner,
  BCard,
  BCardGroup,
  BCardBody,
  BCardTitle,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import axios from "@/libs/axios";
import { toastFailure } from "@/libs/toastification";

export default {
  components: {
    BSpinner,
    BCard,
    BCardGroup,
    BCardBody,
    BCardTitle,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      isLoading: true,
      survey: {
        completed: 0,
        details: null,
      },
    };
  },
  mounted() {
    const { saleId } = { ...this.$route.params };
    axios
      .get(`api/charter-survey/${saleId}`)
      .then((response) => {
        const data = response.data.data || {};
        this.survey = { ...data };
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        toastFailure("Something went wrong.");
      });
  },
};
</script>
